const BACKGROUND_PAGE_RELOADED_CUSTOM_ACTION =
    'GIL036: La página ha sido recargada por el usuario, con lo cual se reinicia el onboarding.',
  BACKGROUND_HAPPENED_NOT_SHOWN_CUSTOM_ACTION =
    'GIL037: No le hemos enseñado el modal de volver al onboarding porque la app está en un estado whitelisteado. El estado del onboarding es: ';

export { BACKGROUND_PAGE_RELOADED_CUSTOM_ACTION, BACKGROUND_HAPPENED_NOT_SHOWN_CUSTOM_ACTION };
